module.exports = __webpack_public_path__ + "img/extended.0f2aa644.png";